import { useState } from 'react'
import { FaEye, FaEyeSlash, FaCheck, FaExclamationTriangle } from 'react-icons/fa'
import './InputDemo.css'

function InputDemo() {
  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    phone: '',
    search: '',
    textarea: ''
  })
  const [errors, setErrors] = useState({})
  const [focused, setFocused] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    // 清除错误
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }))
    }
  }

  const validate = () => {
    const newErrors = {}
    if (!formData.username.trim()) {
      newErrors.username = '用户名不能为空'
    }
    if (!formData.email.trim()) {
      newErrors.email = '邮箱不能为空'
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = '请输入有效的邮箱地址'
    }
    if (!formData.password) {
      newErrors.password = '密码不能为空'
    } else if (formData.password.length < 6) {
      newErrors.password = '密码至少需要6个字符'
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (validate()) {
      alert('表单验证通过！')
    }
  }

  return (
    <div className="input-demo">
      <section className="demo-section">
        <h4>基础输入框</h4>
        <div className="input-row">
          <div className={`input-wrapper ${focused === 'basic' ? 'focused' : ''}`}>
            <label className="input-label">用户名</label>
            <input
              type="text"
              className="input-field"
              placeholder="请输入用户名"
              onFocus={() => setFocused('basic')}
              onBlur={() => setFocused(null)}
            />
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h4>输入框状态</h4>
        <div className="input-row">
          <div className="input-wrapper">
            <label className="input-label">正常状态</label>
            <input
              type="text"
              className="input-field"
              placeholder="正常输入框"
              defaultValue="正常内容"
            />
          </div>
          <div className="input-wrapper">
            <label className="input-label">禁用状态</label>
            <input
              type="text"
              className="input-field"
              placeholder="禁用输入框"
              defaultValue="禁用内容"
              disabled
            />
          </div>
          <div className="input-wrapper error">
            <label className="input-label">错误状态</label>
            <input
              type="text"
              className="input-field"
              placeholder="错误输入框"
              defaultValue="错误内容"
            />
            <span className="error-message">
              <FaExclamationTriangle /> 请输入有效的内容
            </span>
          </div>
          <div className="input-wrapper success">
            <label className="input-label">成功状态</label>
            <input
              type="text"
              className="input-field"
              placeholder="成功输入框"
              defaultValue="成功内容"
            />
            <span className="success-message">
              <FaCheck /> 验证通过
            </span>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h4>密码输入框</h4>
        <div className="input-row">
          <div className="input-wrapper">
            <label className="input-label">密码</label>
            <div className="input-with-icon">
              <input
                type={showPassword ? 'text' : 'password'}
                className="input-field"
                placeholder="请输入密码"
                defaultValue="password123"
              />
              <button
                type="button"
                className="icon-button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h4>表单验证示例</h4>
        <form className="demo-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className={`input-wrapper ${errors.username ? 'error' : ''}`}>
              <label className="input-label">用户名 *</label>
              <input
                type="text"
                name="username"
                className="input-field"
                placeholder="请输入用户名"
                value={formData.username}
                onChange={handleChange}
              />
              {errors.username && (
                <span className="error-message">{errors.username}</span>
              )}
            </div>
            <div className={`input-wrapper ${errors.email ? 'error' : ''}`}>
              <label className="input-label">邮箱 *</label>
              <input
                type="email"
                name="email"
                className="input-field"
                placeholder="请输入邮箱"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <span className="error-message">{errors.email}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className={`input-wrapper ${errors.password ? 'error' : ''}`}>
              <label className="input-label">密码 *</label>
              <input
                type="password"
                name="password"
                className="input-field"
                placeholder="请输入密码"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && (
                <span className="error-message">{errors.password}</span>
              )}
            </div>
            <div className="input-wrapper">
              <label className="input-label">电话</label>
              <input
                type="tel"
                name="phone"
                className="input-field"
                placeholder="请输入电话号码"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary">
              提交表单
            </button>
            <button type="reset" className="btn btn-secondary">
              重置
            </button>
          </div>
        </form>
      </section>
    </div>
  )
}

export default InputDemo